import { axiosInstance } from "@/axios/interceptors";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";
import { z } from "zod";

export const BankLinkingSessionStatusSchema = z
	.object({
		result: z.union([
			z.literal("pending"),
			z.literal("success"),
			z.literal("failed"),
			z.literal("not_found"),
		]),
	})
	.passthrough();

export type BankLinkingSessionStatus = z.infer<
	typeof BankLinkingSessionStatusSchema
>;

export type GetBankLinkingSessionStatusParams = {
	sessionId: string;
	locationId: number;
	guestId: number;
};

export async function getBankLinkingSessionStatus({
	sessionId,
	locationId,
	guestId,
}: GetBankLinkingSessionStatusParams): Promise<BankLinkingSessionStatus> {
	const response = await axiosInstance.get(
		`/locations/${locationId}/guests/${guestId}/kashu/bank-linking/sessions/${sessionId}`,
	);

	return ZodSentryReporter.parse(BankLinkingSessionStatusSchema, response);
}
